// extracted by mini-css-extract-plugin
export default {"stringSwitcher":"StringsSwitcher_stringSwitcher__HJdne"};